import { useDispatch } from 'react-redux';
import { PUSH_ERROR } from '#action/types';

const useError = (...errors) => {
  const dispatch = useDispatch();
  errors.forEach(error => {
    if (error) {
      dispatch({
        type: PUSH_ERROR,
        payload: error
      });
    }
  });
};

export default useError;
